import React from 'react';
import Map from "./Map";
import Main from "./Main";
import ProviderList from "./ProviderList";

const Application = (props) => {
    const query = new URLSearchParams((props.location || {}).search);
    const data = query.get('data');
    const userParams = (props.match || {}).params;

    const element = query.get('element');
    switch (element) {
        case "map":
            return <Map/>;
        case "providers":
            return <ProviderList/>;
        default :
            return <Main
                config={props.config}
                data={data}
                userParams={userParams}
                startQueueName={props.startQueueName}
            />;
    }
};
export default Application;
